module.exports = __webpack_public_path__ + "static/RUmobSlide3-37075648689d2847666bcf07aa2ff1c4.jpg";